export default "__VITE_ASSET__aeebb654__"